import { Badge, Box, Button, Modal } from '@palmetto/palmetto-components';

import { SalesRep, SalesRepStatus, salesRepStatusLabels } from 'types';

import { salesRepStatusBadgeVariant } from './statusBadge';

type SalesRePActionModalProps = {
  isModalOpen: boolean;
  salesRep: SalesRep & { actionToPerform: string };
  handleCloseModal: () => void;
  handleUpdateStatus: (status: SalesRepStatus) => void;
  isLoading: boolean;
};
export const SalesRepActionModal = ({
  isModalOpen,
  salesRep,
  handleCloseModal,
  handleUpdateStatus,
  isLoading,
}: SalesRePActionModalProps) => {
  const isUnblock = salesRep?.actionToPerform === 'unblock';
  const buttonLabel = isUnblock ? 'Unblock' : 'Block';
  const blockOrUnblockAction = isUnblock ? SalesRepStatus.active : SalesRepStatus.blocked;
  return (
    <Modal ariaLabelledBy="titleBasic" isOpen={isModalOpen} onDismiss={handleCloseModal} maxWidth="5xl">
      <Modal.Header
        id="titleBasic"
        title={`${salesRep?.actionToPerform?.charAt(0)?.toUpperCase() + salesRep?.actionToPerform?.slice(1)} Sales Rep`}
        onDismiss={handleCloseModal}
      />
      <Modal.Body childGap="md" background="secondary">
        <Box gap="xs">
          <Box display="flex" direction="row" gap="xs">
            <Box fontWeight="medium">Recheck Id:</Box> {salesRep?.idProviderUser?.idProviderId}
          </Box>
          <Box display="flex" direction="row" gap="xs">
            <Box fontWeight="medium">Name:</Box> {salesRep?.idProviderUser?.displayName}
          </Box>
          <Box display="flex" direction="row" gap="xs">
            <Box fontWeight="medium">Email:</Box> {salesRep?.idProviderUser?.emails?.[0]}
          </Box>
        </Box>
        <Box gap="xs" fontSize="md" display="flex" direction="row" alignContent="center">
          <Box fontWeight="medium">Current Status:</Box>{' '}
          <Badge
            variant={salesRepStatusBadgeVariant[salesRep?.status] ?? 'default'}
            message={salesRepStatusLabels[salesRep?.status]}
          />
        </Box>
        <Box as="p">
          Confirm that you want to {isUnblock ? 'REMOVE' : 'ADD'} this Recheck ID {isUnblock ? 'from' : 'to'} the
          LightReach Global Block List.
        </Box>
      </Modal.Body>
      <Modal.Footer justifyContent="space-between">
        <Button onClick={handleCloseModal} variant="secondary" tone="neutral">
          Cancel
        </Button>
        <Box childGap="sm" display="flex" direction="row">
          {buttonLabel === 'Block' && (
            <Button
              variant="secondary"
              className="shadow-xs"
              onClick={() => handleUpdateStatus(SalesRepStatus.temporarySuspend)}
              style={{ whiteSpace: 'nowrap' }}
              isDisabled={isLoading}
              isLoading={isLoading}
            >
              Temp Suspend
            </Button>
          )}
          <Button
            variant="primary"
            className="shadow-xs"
            onClick={() => handleUpdateStatus(blockOrUnblockAction)}
            style={{ whiteSpace: 'nowrap' }}
            isDisabled={isLoading}
            isLoading={isLoading}
          >
            {buttonLabel}
          </Button>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};
